import { useTranslation } from 'react-i18next';
import { RowActionsMenu, type RowAction } from '@/components/ui/row-actions-menu';

/**
 * The phone list's «···» menu: what the wide header shows as separate buttons (import, exports,
 * «Nuovo viaggio»). It is the row «···» menu with a 44 px trigger, so the platform keeps one
 * popover behaviour. Nothing to offer, nothing shown.
 */
export function ListMoreMenu({ actions }: { readonly actions: readonly RowAction[] }) {
  const { t } = useTranslation('common');
  return (
    <RowActionsMenu
      actions={actions}
      label={t('list.more')}
      triggerClassName="size-11 border border-chip-border bg-card"
    />
  );
}
